import React from "react";
import FloatingField from "./FloatingField";
import Select from "components/CarProduct/component/Select";

export default function BuyerInfoSection({
  form,
  updateField,
  setFieldTouched,
  insuredAddressError,
  insuredProvinceError,
  insuredWardError,
  buyerProvinceError,
  buyerWardError,
  buyerNameError,
  phoneError,
  emailError,
  addressError,
  provinces,
  insuredWards,
  buyerWards,
  loadingProvinces,
  loadingInsuredWards,
  loadingBuyerWards,
  handleInsuredProvinceChange,
  handleBuyerProvinceChange,
  sameAsInsuredAddress,
  handleToggleSameAddress,
}) {
  return (
    <>
      <h2 className="fire-explosion__section-title">
        Thông tin người bán
      </h2>
      <FloatingField
        id="fe-seller-name"
        label="Tên người bán"
        placeholder="Nhập tên người bán"
        value={form.sellerName}
        onChange={(e) => updateField("sellerName", e.target.value)}
      />

      <h2 className="fire-explosion__section-title fire-explosion__section-title--spaced">
        Thông tin bên mua bảo hiểm
      </h2>

      <div className="fire-explosion__radio-row fire-explosion__radio-row--horizontal">
        <label className="fire-explosion__radio">
          <input
            type="radio"
            name="buyerType"
            checked={form.buyerType === "non_commercial"}
            onChange={() => updateField("buyerType", "non_commercial")}
          />
          <span>Chủ sở hữu</span>
        </label>
        <label className="fire-explosion__radio">
          <input
            type="radio"
            name="buyerType"
            checked={form.buyerType === "commercial"}
            onChange={() => updateField("buyerType", "commercial")}
          />
          <span>Người thuê nhà/ mặt bằng</span>
        </label>
      </div>

      {/* ──── Địa chỉ được bảo hiểm (homeOwner / homeOwnerInfo) ──── */}
      <h3 className="fire-explosion__section-title fire-explosion__section-title--spaced">
        Địa chỉ được bảo hiểm
      </h3>
      <div className="fire-explosion__section-subtitle">
        Nơi đặt cửa hàng / kho hàng cần bảo hiểm
      </div>

      <div className="fire-explosion__input-box-wrap">
        <Select
          className={form.insuredProvince?.code ? "select-input--filled" : ""}
          title={"Chọn Tỉnh/Thành phố"}
          placeholder={"Tỉnh/Thành phố (địa chỉ bảo hiểm)"}
          error={insuredProvinceError}
          selectedValue={form.insuredProvince || {}}
          data={provinces || []}
          onValueChange={(val) => {
            handleInsuredProvinceChange(val);
            setFieldTouched((prev) => ({ ...prev, insuredProvince: true }));
          }}
          isLoading={loadingProvinces}
          require
          heightModal="50vh"
        />
        {insuredProvinceError ? (
          <div className="fire-explosion__error">{insuredProvinceError}</div>
        ) : null}
      </div>

      <div className="fire-explosion__input-box-wrap">
        <Select
          className={form.insuredWard?.code ? "select-input--filled" : ""}
          title={"Chọn Phường/Xã"}
          placeholder={"Phường/Xã (địa chỉ bảo hiểm)"}
          error={insuredWardError}
          selectedValue={form.insuredWard || {}}
          data={insuredWards || []}
          disabled={!form.insuredProvince?.code}
          onValueChange={(val) => {
            updateField("insuredWard", val);
            setFieldTouched((prev) => ({ ...prev, insuredWard: true }));
            if (sameAsInsuredAddress) {
              updateField("buyerWard", val);
            }
          }}
          isLoading={loadingInsuredWards}
          require
          heightModal="50vh"
        />
        {insuredWardError ? (
          <div className="fire-explosion__error">{insuredWardError}</div>
        ) : null}
      </div>

      <FloatingField
        id="fe-insured-address"
        label="Số nhà, tên đường..."
        placeholder="Nhập địa chỉ được bảo hiểm"
        error={insuredAddressError}
        value={form.insuredAddress}
        onBlur={() =>
          setFieldTouched((prev) => ({ ...prev, insuredAddress: true }))
        }
        onChange={(e) => {
          updateField("insuredAddress", e.target.value);
          if (sameAsInsuredAddress) {
            updateField("address", e.target.value);
          }
        }}
      />

      {/* ──── Thông tin liên hệ ──── */}
      <h3 className="fire-explosion__section-title fire-explosion__section-title--spaced">
        Thông tin liên hệ
      </h3>
      <div className="fire-explosion__section-subtitle">
        Người đứng tên mua bảo hiểm
      </div>

      <FloatingField
        id="fe-buyer-name"
        label="Tên bên mua bảo hiểm"
        placeholder="Nhập họ và tên"
        error={buyerNameError}
        value={form.buyerName}
        onBlur={() => setFieldTouched((prev) => ({ ...prev, buyerName: true }))}
        onChange={(e) => updateField("buyerName", e.target.value)}
      />

      <FloatingField
        id="fe-buyer-phone"
        label="Số điện thoại người mua"
        placeholder="VD: 0912345678 hoặc 84912345678"
        error={phoneError}
        value={form.buyerPhone}
        inputMode="tel"
        autoComplete="tel"
        onBlur={() =>
          setFieldTouched((prev) => ({ ...prev, buyerPhone: true }))
        }
        onChange={(e) => updateField("buyerPhone", e.target.value)}
      />

      <FloatingField
        id="fe-email"
        label="Email"
        placeholder="Nhập email"
        error={emailError}
        type="email"
        autoComplete="email"
        value={form.email}
        onBlur={() => setFieldTouched((prev) => ({ ...prev, email: true }))}
        onChange={(e) => updateField("email", e.target.value)}
      />

      <div className="fire-explosion__checkbox-row">
        <label className="fire-explosion__checkbox">
          <input
            type="checkbox"
            checked={sameAsInsuredAddress}
            onChange={(e) => handleToggleSameAddress(e.target.checked)}
          />
          <span>Địa chỉ thông tin liên hệ trùng với địa chỉ bảo hiểm</span>
        </label>
      </div>

      <div
        className={`fire-explosion__collapsible-address ${sameAsInsuredAddress
          ? "fire-explosion__collapsible-address--collapsed"
          : "fire-explosion__collapsible-address--expanded"
          }`}
      >
        <div className="fire-explosion__collapsible-address-title">Địa chỉ thông tin liên hệ</div>
        <div className="fire-explosion__input-box-wrap">
          <Select
            className={form.buyerProvince?.code ? "select-input--filled" : ""}
            title={"Chọn Tỉnh/Thành phố"}
            placeholder={"Tỉnh/Thành phố"}
            error={buyerProvinceError}
            selectedValue={form.buyerProvince || {}}
            data={provinces || []}
            onValueChange={(val) => {
              handleBuyerProvinceChange(val);
              setFieldTouched((prev) => ({ ...prev, buyerProvince: true }));
            }}
            isLoading={loadingProvinces}
            require
            heightModal="50vh"
          />
          {buyerProvinceError ? (
            <div className="fire-explosion__error">{buyerProvinceError}</div>
          ) : null}
        </div>

        <div className="fire-explosion__input-box-wrap">
          <Select
            className={form.buyerWard?.code ? "select-input--filled" : ""}
            title={"Chọn Phường/Xã"}
            placeholder={"Phường/Xã"}
            error={buyerWardError}
            selectedValue={form.buyerWard || {}}
            data={buyerWards || []}
            disabled={!form.buyerProvince?.code}
            onValueChange={(val) => {
              updateField("buyerWard", val);
              setFieldTouched((prev) => ({ ...prev, buyerWard: true }));
            }}
            isLoading={loadingBuyerWards}
            require
            heightModal="50vh"
          />
          {buyerWardError ? (
            <div className="fire-explosion__error">{buyerWardError}</div>
          ) : null}
        </div>

        <FloatingField
          id="fe-address"
          label="Số nhà, tên đường..."
          placeholder="Nhập địa chỉ liên hệ"
          error={addressError}
          value={form.address}
          onBlur={() => setFieldTouched((prev) => ({ ...prev, address: true }))}
          onChange={(e) => updateField("address", e.target.value)}
        />
      </div>
    </>
  );
}
